import AssignJobListView from "./AssignJobListView";
export default AssignJobListView;